import React from "react";

interface Props {
  className?: string;
}

export const LogoWhite: React.FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 104 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xlinkTitle="Sudozi Logo"
    >
      <title>Sudozi logo. Click to go home.</title>
      <g clipPath="url(#clip0_10962_179952)">
        <path
          d="M27.5253 15.3558C27.5253 16.9607 28.3992 17.836 30.1468 17.836C31.7488 17.836 32.6226 16.9607 32.6226 15.9394C32.6226 13.1674 23.5931 14.7722 23.5931 8.20687C23.5931 5.43483 26.069 2.95459 30.1468 2.95459C34.079 2.95459 36.5548 5.43483 36.5548 8.79046L32.477 9.08225C32.477 7.62328 31.6032 6.7479 30.1468 6.7479C28.8361 6.7479 27.9623 7.62328 27.9623 8.49866C27.9623 11.1248 36.9918 9.51994 36.9918 16.2312C36.9918 19.1491 34.5159 21.6294 30.1468 21.6294C25.9233 21.6294 23.4475 19.1491 23.4475 15.6476L27.5253 15.3558Z"
          fill="white"
        />
        <path
          d="M39.1763 8.06104H43.1085V15.21C43.1085 16.9607 44.1279 17.982 45.5843 17.982C47.0407 17.982 48.0601 16.9607 48.0601 15.21V8.06104H51.9923V21.4835H49.0796L48.4971 20.1705C48.4971 20.1705 46.895 21.6294 44.5648 21.6294C41.3608 21.6294 39.1763 19.441 39.1763 15.9395V8.06104V8.06104Z"
          fill="white"
        />
        <path
          d="M64.3715 20.1705C64.3715 20.1705 62.9151 21.6295 60.5849 21.6295C57.2353 21.6295 54.3225 18.7115 54.3225 14.7723C54.3225 10.8331 57.2353 7.91518 60.5849 7.91518C62.6238 7.91518 63.9346 9.08235 63.9346 9.08235V3.10059H67.8668V21.4836H64.954L64.3715 20.1705ZM64.0802 14.7723C64.0802 12.8757 62.7695 11.5626 61.1675 11.5626C59.5654 11.5626 58.2547 12.8757 58.2547 14.7723C58.2547 16.669 59.5654 17.982 61.1675 17.982C62.7695 17.982 64.0802 16.669 64.0802 14.7723Z"
          fill="white"
        />
        <path
          d="M77.042 7.76904C80.8285 7.76904 83.8869 10.8329 83.8869 14.7721C83.8869 18.7113 80.8285 21.7751 77.042 21.7751C73.2554 21.7751 70.197 18.7113 70.197 14.7721C70.197 10.8329 73.2554 7.76904 77.042 7.76904ZM77.042 11.4165C75.44 11.4165 74.1292 12.7295 74.1292 14.7721C74.1292 16.8146 75.44 18.1277 77.042 18.1277C78.644 18.1277 79.9547 16.8146 79.9547 14.7721C79.9547 12.7295 78.644 11.4165 77.042 11.4165Z"
          fill="white"
        />
        <path
          d="M85.6345 18.2738L91.1687 11.8543H85.6345V8.06104H96.266V11.2708L90.7318 17.6902H96.5573V21.4835H85.6345V18.2738Z"
          fill="white"
        />
        <path
          d="M100.926 2.2251C102.092 2.2251 103.111 3.24637 103.111 4.41355C103.111 5.58072 102.092 6.602 100.926 6.602C99.7614 6.602 98.7419 5.58072 98.7419 4.41355C98.7419 3.24637 99.7614 2.2251 100.926 2.2251ZM98.8876 8.06096H102.82V21.4835H98.8876V8.06096Z"
          fill="white"
        />
        <path
          d="M7.06327 24C2.40288 24 0.109098 21.7386 -0.000130335 19.6231C-0.109358 18.0182 0.582419 15.2827 6.18945 15.2827C6.33509 15.2827 6.58995 15.2827 6.58995 15.2827C8.41042 15.2827 9.32065 14.2979 10.1217 13.4225C10.9955 12.4742 11.7601 11.6353 13.799 11.6353C18.8599 11.6353 17.4399 18.8207 14.0539 21.6656C12.2698 23.1611 9.72115 24 7.06327 24Z"
          fill="#03D78A"
        />
        <path
          d="M11.8328 0C16.4931 0 18.7869 2.2614 18.8962 4.3769C19.0054 5.98176 18.3136 8.71733 12.7066 8.71733C12.5609 8.71733 12.3061 8.71733 12.3061 8.71733C10.4856 8.71733 9.57538 9.70213 8.77437 10.5775C7.90055 11.5258 7.13596 12.3647 5.09704 12.3647C0.0361445 12.3647 1.45611 5.17933 4.84217 2.33435C6.62623 0.87538 9.17488 0 11.8328 0Z"
          fill="#03D78A"
        />
      </g>
      <defs>
        <clipPath id="clip0_10962_179952">
          <rect width="103.111" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
